import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { deleteCostCenter } from '../../../../../../../lib/api/accounting';
import CustomButton from '../../../../../../../lib/designSystem/Button';
import { showAlert } from '../../../../../../../lib/functions/utils';

interface CostCenterDetailsProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  setUp: () => void;
  costCenter: {
    id: string;
    name: string;
  };
  setCostCenter: (costCenter: any) => void;
  handelOpenEditModal: () => void;
  setSuccess: (success: string) => void;
}

const CostCenterDetails: React.FC<CostCenterDetailsProps> = ({
  open,
  setOpen,
  setUp,
  costCenter,
  setCostCenter,
  handelOpenEditModal,
  setSuccess,
}) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (
      !window.confirm(
        '¿Estás seguro de que quieres eliminar este centro de costo?',
      )
    ) {
      return;
    }

    setLoading(true);
    try {
      await deleteCostCenter(dispatch, costCenter.id);
      setSuccess('Centro de costo eliminado correctamente');
      setUp();
      setOpen(false);
      setCostCenter({ id: '', name: '' });
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al eliminar el centro de costo');
    }
    setLoading(false);
  };

  const handleEdit = () => {
    handelOpenEditModal();
  };

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
      <DialogTitle>Detalles del Centro de Costo</DialogTitle>
      <DialogContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Nombre
          </Typography>
          <Typography variant="body1" sx={{ mt: 1 }}>
            {costCenter.name}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={() => setOpen(false)} color="secondary">
          Cerrar
        </CustomButton>
        <CustomButton onClick={handleEdit} color="primary">
          Editar
        </CustomButton>
        <CustomButton onClick={handleDelete} color="error" disabled={loading}>
          Eliminar
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default CostCenterDetails;
